import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const SimPolygon = ({ Inverted = false, sx }) => {
	const theme = useTheme();
	const sxProps = sx || {
		bottom: -2,
		height: '25%'
	};

	return (
		<Box
			component={'svg'}
			preserveAspectRatio='none'
			xmlns='http://www.w3.org/2000/svg'
			x='0px'
			y='0px'
			viewBox='0 0 1921 273'
			sx={{ position: 'absolute', width: '100%', left: 0, right: 0, zIndex: 1, ...sxProps }}>
			{Inverted ? (
				<polygon fill={theme.palette.background.default} points='0,273 1921,273  1921,200 0,0 ' />
			) : (
				<polygon fill={theme.palette.background.default} points='0,273 1921,273 1921,0 ' />
			)}
		</Box>
	);
};

export default SimPolygon;
